import Swal from "sweetalert2";
const Subscription = {
  install(Vue) {
    // Get parsed subscription data from sessionStorage
    Vue.prototype.$getSubscription = function () {
      try {
        const subscription = JSON.parse(sessionStorage.getItem('subscription'));
        return subscription || null;
      } catch (e) {
        console.error('Subscription parse error:', e);
        return null;
      }
    };

    // Get plan name
    Vue.prototype.$getPlanName = function () {
      const sub = this.$getSubscription();
      return sub?.plan?.name || 'N/A';
    };

    // Get plan price
    Vue.prototype.$getPlanPrice = function () {
      const sub = this.$getSubscription();
      return sub?.plan?.price || '0.00';
    };

    // Check if subscription is active
    Vue.prototype.$hasActiveSubscription = function () {
      const sub = this.$getSubscription();
      return sub?.status === 'active';
    };

    // Get plan features as array
    Vue.prototype.$getPlanFeatures = function () {
      const sub = this.$getSubscription();
      try {
        return JSON.parse(sub?.plan?.features || '[]');
      } catch (e) {
        console.error('Feature parse error:', e);
        return [];
      }
    };
    Vue.prototype.$redirectToBilling = function () {
      this.$router.push('/system-setting/billing');
    };
    Vue.prototype.$checkPlan = function () {
      const planName = this.$getPlanName(); // Make sure this method is available

      if (['Premium', 'Pro'].includes(planName)) {
        return true;
      } else {
        this.$showUpgradeAlert();
        return false;
      }
    };
    Vue.prototype.$showUpgradeAlert = function () {
      Swal.fire({
        title: "Upgrade Required",
        text: "This feature is only available for Premium and Pro plans. Please upgrade your plan to access this functionality.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Upgrade Plan",
        cancelButtonText: "Cancel",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-secondary",
        buttonsStyling: false,
        heightAuto: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$redirectToBilling();
        }
      });
    }
  }
};

export default Subscription;
